import React, { useState, useEffect } from 'react';
import styles from './viewCVGroup.module.scss';
import ReactGA from 'react-ga4';
import { Helmet } from "react-helmet";
import CustomNavbar from '../../customNavbar';
import { Col, Row } from 'react-bootstrap';
import CSSLoader from '../../../shared/cssLoader';
import { getAllCVReviewGroupDetails } from '../../../../services/util/cvReview';
import { CustomSearch } from '../../../shared/customSearch';
import { CustomButton } from '../../../shared/customButton';
import Avatar from 'react-avatar';

function ViewCVGroup(props) {
    let [accordionIcon, setAccordionIcon] = useState(true);
    let [candidateList, setCandidateList] = useState([]);
    let [filteredValues, setFilteredValues] = useState([]);
    let [commonData, setCommonData] = useState({});
    let [isURLLoading, setURLLoading] = useState(false);
    const [isLoading, setLoading] = useState(false);
    let [getUsersIsLoading, getUsersSetLoading] = useState(false);
    let [cvReviewValues, setCVReviewValues] = useState([]);

    const breadcrumb = [
        {
            pathaddress: '/app/company/reviews',
            pathname: 'CV Reviews',
            isActive: false,
            key: 1 + 'cv-review'
        },
        {
            pathaddress: '',
            pathname: commonData.step_name,
            isActive: true,
            key: 1 + commonData.step_name
        }
    ];

    const breacrumbText = 'Here you can see candidate profiles waiting for your feedback. CVs get automatically assigned to you if you were assigned as a CV reviewer in a pipeline.'

    const changeAccordionIcon = () => {
        setAccordionIcon(!accordionIcon)
    }

    const viewCVReview = (values) => {
        props.history(`/company/reviews/${values}`);
    }

    //searching assessments
    function searchValues(searchValue) {
        let searchVal = searchValue.toLowerCase();
        if (searchValue == '') {
            setCandidateList(filteredValues)
        } else {
            const filtered = filteredValues.filter(entry => Object.values(entry).some(val => typeof val === "string" && (val.toLowerCase()).includes(searchVal)));
            setCandidateList(filtered);
        }

    }

    async function loadInitialData() {
        setLoading(true);
        //getting query parameter value
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let step_id = params.get('step_id');
        if (step_id) {
            let respond = await getAllCVReviewGroupDetails(step_id);
            if (respond.success === true) {
                if (respond.data && respond.data.common_details && respond.data.candidate_object_list) {
                    setCommonData(respond.data.common_details);
                    setCandidateList(respond.data.candidate_object_list);
                    setFilteredValues(respond.data.candidate_object_list);
                    setCVReviewValues(respond.data.cv_values)
                    setLoading(false);
                } else {
                    props.history(`/company/reviews`);
                }
            } else {
                props.history(`/company/reviews`);
                setLoading(false);
            }
        }
    }

    const itemsPerPage = 9; // Number of items to display per page
    const [currentPage, setCurrentPage] = useState(1); // Current page number

    const handlePreviousClick = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextClick = () => {
        const totalPages = Math.ceil(candidateList.length / itemsPerPage);
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };
    const totalPages = Math.ceil(candidateList.length / itemsPerPage);

    useEffect(() => {
        loadInitialData();
    }, [])

    useEffect(() => {
        let pageHit = '/app/company/cv-reviews';
        props.toggleInterviewView(false);
        ReactGA.initialize(`${process.env.REACT_APP_CUSTOMER_FLOW_GOOGLE_ANALYTICS_ID}`);
        ReactGA.send({ hitType: "pageview", page: pageHit});
    }, [])

    return (
        <div>
            <Helmet>
                <title>CV Reviews | HireTrace</title>
            </Helmet>
            {isLoading ?
                <div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>
                :
                <div>

                    <div className={styles.backgroundFixedComponents}>
                        <CustomNavbar history={props.mainHistory} breadcrumbArray={breadcrumb} breacrumbText= {breacrumbText}/>
                    </div>

                    <div className={styles.BodyContainer}>
                        <Col>
                            <Col>
                                <div>
                                    <Row>
                                        <Col sm={6} className={styles.PipelineDetailsCol}>
                                            <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Pipeline : </span><span className={styles.reviewDetailsValue} id="adminPanel_cvReviews_viewGroup_pipelineNameTypeId">{commonData.pipeline_name}</span></p>
                                            <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Position : </span><span className={styles.reviewDetailsValue} id="adminPanel_cvReviews_viewGroup_pipelinePositionTypeId">{commonData.hiring_position}</span></p>
                                        </Col>
                                        <Col sm={6} className="mb-2">
                                            <div className={styles.searchbar}>
                                            <CustomSearch
                                                placeholder="Search by name"
                                                handleOnChange={(e) => searchValues(e.target.value)}
                                            />
                                            </div>
                                        </Col>

                                    </Row>
                                </div>
                            </Col>


                            <div className={styles.tableContainer}>
                                <div className={styles.tableFirstRowMainHeaderDiv}>
                                    <Col sm={4} className={styles.tableDetailsMainHeaderRow}>
                                        <p>Candidate Details</p>
                                    </Col>
                                    <Col sm={2}>
                                        <Row className={styles.tableInfoDetailsMainHeaderRow}>
                                            <p>Phone Number</p>
                                        </Row>
                                    </Col>
                                    <Col sm={2}>
                                        <Row className={styles.tableDetailsMarksHeaderRow}>
                                            <p>Passing Threshold</p>
                                        </Row>
                                    </Col>
                                    <Col sm={1}>
                                        <Row className={styles.tableDetailsMarksHeaderRow}>
                                            <p>Overall Marks</p>
                                        </Row>
                                    </Col>
                                    <Col sm={3}>
                                        <Row className={styles.tableCandidatesInfoDetailsHeaderRow}>
                                            <p>Review</p>
                                        </Row>
                                    </Col>
                                </div>
                                {candidateList?.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map((cvReview, i) => {
                                    return (
                                        <div className={i % 2 === 0 ? styles.tableRowMainDiv : styles.tableRowSecondMainDiv}>
                                            <Col sm={4}>
                                                <Row className={styles.tableJobDetailsMainRow}>
                                                    <Col sm={2}>
                                                        <Avatar name={cvReview.candidate_name} size="36" round={true} />
                                                    </Col>
                                                    <Col sm={10}>
                                                        <Row className={styles.tableJobDetailsRow}>
                                                            <p className={styles.tableJobDetails} id={`adminPanel_cvReviews_viewGroup_candidateNameId.${i}`}>{cvReview?.candidate_name}</p>
                                                        </Row>
                                                        <Row className={styles.tableJobDetailsRow}>
                                                            <p className={styles.tableSecondJobDetails} id={`adminPanel_cvReviews_viewGroup_candidateEmailId.${i}`}>{cvReview?.candidate_email}</p>
                                                        </Row>
                                                    </Col>

                                                </Row>

                                            </Col>

                                            <Col sm={2}>
                                                <Row className={styles.tableCandidatesInfoDetailsRow}>
                                                    <p className={styles.tableCandidatesInfoDetails} id={`adminPanel_cvReviews_viewGroup_mobileNumberId.${i}`}>({cvReview.candidate_mobile_country_code}) {cvReview.candidate_mobile}</p>
                                                </Row>
                                            </Col>
                                            <Col sm={2}>
                                                <Row className={styles.tableCandidatesInfoDetailsRow}>
                                                    <p className={styles.tableCandidatesInfoDetails} id={`adminPanel_cvReviews_viewGroup_passingThresholdId.${i}`}>{cvReview.candidate_pass_score}%</p>
                                                </Row>
                                            </Col>
                                            <Col sm={1}>
                                            <Row className={styles.tableCandidatesInfoDetailsRow}>
                                                    {cvReview.candidate_overall_marks !== null ? (
                                                        <p className={styles.tableCandidatesInfoDetails}>
                                                            {cvReview.candidate_overall_marks.toFixed(0)}%
                                                        </p>
                                                    ) : (
                                                        <p className={styles.tableCandidatesInfoDetails}>N/A</p>
                                                    )}
                                                </Row>
                                            </Col>
                                            <Col sm={3}>
                                                <Row className={styles.tableCandidatesInfoDetailsButtonRow}>
                                                    <CustomButton
                                                        buttonType="button"
                                                        label="Review Candidate"
                                                        id={`adminPanel_cvReviews_viewGroup_reviewCandidateBtnId.${i}`}
                                                        type="secondaryBtn"
                                                        backicon={
                                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M9 12L12 9L9 6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M6 9H12" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                            </svg>
                                                        }
                                                        handleClick={() => viewCVReview(cvReview.cv_review_session_id)}
                                                    />
                                                </Row>
                                            </Col>
                                        </div>
                                    );

                                })
                                }

                            </div>
                            {candidateList.length > 9 && getUsersIsLoading === false &&
                                <div className={styles.bottomTableDiv}>
                                    <div className={styles.bottomTableControlsWrapper}>
                                        <div className={styles.bottomTableControlsNextBtn}>
                                            <CustomButton
                                                id="cv_review_go_to_previous_page_btn"
                                                label="Previous"
                                                handleClick={handlePreviousClick}
                                                disabled={currentPage === 1}
                                                type="defaultSmallBtn"
                                            />
                                        </div>
                                        <div>
                                            <CustomButton
                                                id="cv_review_go_to_next_page_btn"
                                                label="Next"
                                                type="defaultSmallBtn"
                                                handleClick={handleNextClick}
                                                disabled={currentPage === Math.ceil(candidateList.length / itemsPerPage)}
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <span className={styles.paginationInfo}>
                                            Page {currentPage} of {totalPages}
                                        </span>
                                    </div>
                                </div>
                            }
                        </Col>
                    </div>
                </div>
            }
        </div>
    )
}

export default ViewCVGroup;
